import { SxProps } from '@mui/system';
import { ICalendarEventType } from '@pharmaplan/common';

const styles = {
  container: (eventType: ICalendarEventType) =>
    ({
      padding: 0,
      borderRadius: '5px',
      border: '1px solid',
      borderColor: `calendarHover.${eventType}Border`,
      backgroundColor: `calendarHover.${eventType}`,
      color: 'common.grey850',
    }),

  arrow: (eventType: ICalendarEventType) =>
    ({
      color: `calendarHover.${eventType}`,
      '&:before': {
        border: '1px solid',
        borderColor: `calendarHover.${eventType}Border`,
      },
    }),
} satisfies Record<
  string,
  SxProps | ((eventType: ICalendarEventType) => SxProps)
>;

export default styles;
